export const experience = [
  {
    role: "Data Scientist & Cloud Engineer",
    org: "GlowingSoft Technologies",
    period: "Aug 2025   Present",
    points: [
      "Built predictive ML models with integrated cloud-based data pipelines to deliver actionable insights.",
      "Automated workflows using AI tools and deployed scalable Azure infrastructure with Terraform (IaC).",
      "Managed and optimized Azure data storage, compute, and ML services to support analytics and predictive modeling.",
    ],
  },
  {
    role: "Junior DevOps Engineer",
    org: "Cybersoft North America",
    period: "Apr 2025   Aug 2025",
    points: [
      "Built and maintained CI/CD pipelines in Azure DevOps, provisioning scalable infrastructure with Terraform.",
      "Automated data workflows and database pipelines using Python & Bash, reducing processing time by 30%.",
      "Optimized cloud resources with Azure Cost Management, cutting costs by 15%.",
    ],
  },
  {
    role: "Junior Data Scientist",
    org: "Coding Square Technologies",
    period: "May 2024   May 2025",
    points: [
      "Preprocessed large datasets to improve ML model performance.",
      "Designed and deployed OCR models for extracting data from government documents, increasing digitization accuracy by 40%.",
      "Integrated AI-driven solutions into client systems, enhancing decision-making processes.",
    ],
  },
];

// Academic / research projects, separate from the live AI tools elsewhere
// in this portfolio.
export const notableProjects = [
  {
    title: "CCTV Video Analytics for Insight Extraction",
    tag: "Final Year Project",
    icon: "🎥",
    color: "#4f9dff",
    description: "Object detection system using YOLO, OpenCV & TensorFlow with 92% detection accuracy.",
  },
  {
    title: "Deepfake Audio Detection",
    tag: "AI Voice Authentication",
    icon: "🎙️",
    color: "#ff7aa8",
    description: "Deepfake audio detection model using wav2vec 2.0 XLS-R, AASIST, and OC-Softmax.",
  },
  {
    title: "LangGraph Autonomous Chrome Dragon Game",
    tag: "Agentic AI",
    icon: "🕹️",
    color: "#9b7bff",
    description: "Self-generating Chrome Dragon game built with LangGraph using dynamic Engineer and QA nodes.",
  },
  {
    title: "Vision-Based Autonomous Robot Navigation",
    tag: "Computer Vision",
    icon: "🤖",
    color: "#35c9b5",
    description: "AI vision system for real-time scene segmentation and autonomous navigation using PIDNet.",
  },
  {
    title: "Brain Tumor MRI Detection",
    tag: "Deep Learning",
    icon: "🧬",
    color: "#e0a458",
    description: "Deep learning models applied to a Kaggle MRI dataset, comparing approaches to optimize accuracy.",
  },
  {
    title: "Real-Time Face Detection & Email Notification",
    tag: "Computer Vision",
    icon: "📷",
    color: "#35c9b5",
    description: "Webcam-based face detection system with automated email notifications.",
  },
  {
    title: "Stream Data Handling with Databricks",
    tag: "Data Engineering",
    icon: "🗄️",
    color: "#6fcf7a",
    description: "Real-time stream data processing and catalog management with Gold, Silver, and Bronze layers.",
  },
  {
    title: "RAG Pipelines with LangChain",
    tag: "Retrieval-Augmented Generation",
    icon: "🔗",
    color: "#4f9dff",
    description: "RAG pipelines with LangChain and LangGraph for efficient file search and LLM-powered retrieval.",
  },
];
